import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/SettingSellProductOrganizer';
import withAuth from '../../common/WithAuth';
import SettingSellProductOrganizer from '../../pages/SettingSellProductOrganizer/SettingSellProductOrganizer';

const mapStateToProps = (state) => ({
    infoSettingProduct: state.settingSellProductOrganizer.get.data,
    isLoading: state.settingSellProductOrganizer.get.isFetching || state.settingSellProductOrganizer.update.isFetching,
    errorGetSetting: state.settingSellProductOrganizer.get.errors,
    updateSuccess: state.settingSellProductOrganizer.update.updateSuccess,
    companyId: state.companyManagementOrganizer.detailCompanyOrganizerForSideBar
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.company
        && state.companyManagementOrganizer.detailCompanyOrganizerForSideBar.data.company.id,
    errorUpdate: state.settingSellProductOrganizer.update.errors,
    customTextSidebar: state.registrationOrganizer.registrationOrganizer.data?.settings_texts_sidebar_organizer,
});

const mapDispatchToProps = (dispatch) => ({
    getSettingSellProductOrganizer: (params) => {
        dispatch(Actions.GetSettingSellProductOrganizerRequested(params));
    },
    clearSettingProduct: () => {
        dispatch(Actions.ClearSettingSellProductOrganizer());
    },
    updateSettingSellProductOrganizer: (params) => {
        dispatch(Actions.UpdateSettingSellProductOrganizerRequested(params));
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(SettingSellProductOrganizer);
